
import {
  RadioTower,
  Plus,
  Search,
  FileText,
  ChevronRight
} from "lucide-react";

import "../Styles/SimCards.css";
import NewSimModal from "../Components/NewSimModal";

import React, {
  useState,
  useEffect,
  useMemo
} from "react";

import api from "../api";

import rcsLogo from "../assets/rcslogo.png";

import {
  toast
} from "react-toastify";

import {
  useNavigate
} from "react-router-dom";

const SimCards = () => {

  const [search, setSearch] =
    useState("");

const [isModalOpen, setModalOpen] =
  useState(false);

const [sims, setSims] =
useState([]);

const [loading, setLoading] =
useState(false);

const navigate =
useNavigate();

const [allSims, setAllSims] =
useState([]);


const addSim =
async (sim) => {

try {

const created =
await api.createSim(sim);

setSims(prev => [

created,

...prev

]);

setModalOpen(false);

toast.success(
"SIM added."
);

}

catch (err) {

console.error(err);

toast.error(

err.response?.data?.error ||

"Failed to create SIM."

);

}

};


useEffect(() => {

  fetchSims();

}, []);


async function fetchSims() {

  try {

    setLoading(true);

    const data =
      await api.getSimCards();

    setSims(data);
setAllSims(data);

  }

  catch (err) {

    console.error(err);

    toast.error(
      "Failed to load SIM cards."
    );

  }

  finally {

    setLoading(false);

  }

}


const deleteSim =
async (id) => {

if(

!window.confirm(

"Delete this SIM?"

)

){

return;

}

try{

await api.deleteSim(id);

setSims(

prev=>

prev.filter(

sim=>

sim.id!==id

)

);

toast.success(

"SIM deleted."

);

}

catch(err){

console.error(err);

toast.error(

"Delete failed."

);

}

};



  return (

    <div className="sim-page">

{loading && (
  <div className="sim-loading-overlay">
    <div className="sim-loading-screen">

      <div className="sim-loader">
        <div className="sim-loader-ring" />

        <img
          src={rcsLogo}
          alt="RCS"
          className="sim-loader-logo"
        />
      </div>

      <h2>Searching SIM Inventory</h2>

      <p>
        Looking up GSM numbers,
        serial numbers and
        customer records...
      </p>

    </div>
  </div>
)}

      {/* HERO */}

      <div className="sim-hero">

        <div>

          <div className="sim-pill">

            <RadioTower size={15} />

            <span>
              SIM Inventory
            </span>

          </div>

          <h1>
            SIM Card Management
          </h1>

          <p>
            Store, search and
            manage GSM numbers,
            serial numbers and
            network assignments.
          </p>

        </div>

        <div className="sim-actions">

          <button className="glass-btn secondary">

            <FileText size={18} />

            Reports

          </button>

          <button
  className="glass-btn primary"
  onClick={() =>
    setModalOpen(true)
  }
>

            <Plus size={18} />

            New SIM

          </button>

        </div>

      </div>

      {/* STATS */}

      <div className="sim-stats">

        <div className="sim-stat-card">

          <h4>Total SIMs</h4>

          <h2>{allSims.length}</h2>

        </div>

        <div className="sim-stat-card">

          <h4>Available</h4>

<h2>{
allSims.filter(
sim =>
sim.status === "AVAILABLE"
).length
}</h2>

        </div>

        <div className="sim-stat-card">

          <h4>Sold</h4>

<h2>{
allSims.filter(
sim =>
sim.status === "SOLD"
).length
}</h2>
        </div>

        <div className="sim-stat-card">

          <h4>Networks</h4>

<h2>{
new Set(
allSims.map(
sim => sim.network
)
).size
}</h2>

        </div>

      </div>

      {/* TABLE */}

      <div className="sim-table-wrapper">

        <div className="table-toolbar">

          <div className="search-box">

            <Search size={18} />

            <input
              type="text"
              placeholder="Search GSM or Serial..."
              value={search}
onChange={async (e)=>{

const value =
e.target.value;

setSearch(value);

if(value.trim().length < 3){

setLoading(false);

setSims([]);

return;

}

try{

setLoading(true);

const results =
await api.searchSimCards(
value
);

setSims(
results.slice(0,10)
);

}

catch(err){

console.error(err);

}

finally{

setLoading(false);

}

}}
            />

          </div>

        </div>

        <div className="sim-table">

          <div className="table-head">

            <span>
              GSM Number
            </span>

            <span>
              Serial Number
            </span>

            <span>
              Network
            </span>

            <span>
              Status
            </span>

            <span>
              Actions
            </span>

          </div>

          {

sims.length === 0

?

(

<div className="sim-empty">

<Search size={42}/>

<h3>

Search SIM Inventory

</h3>

<p>

Type at least 3 characters
to begin searching.

</p>

</div>

)

:

sims.map(sim=>(


            <div
              key={sim.id}
              className="table-row"
            >

              <div>
               {sim.gsm_number}
              </div>

              <div>
                {sim.serial_number}
              </div>

              <div>
                {sim.network}
              </div>

              <div>

                <span
                  className={
                  sim.status === "AVAILABLE"
                    ? "status-pill available"
                    : "status-pill sold"
                  }
                >

                  {sim.status}

                </span>

              </div>

              <div>

<button
  className="open-btn"
  onClick={() =>
    navigate(`/sim-cards/${sim.id}`)
  }
>
  <ChevronRight size={16} />
  Open
</button>

              </div>

            </div>

          ))}

        </div>

      </div>



{isModalOpen && (

  <NewSimModal

    closeModal={() =>
      setModalOpen(false)
    }

    addSim={addSim}

  />

)}

    </div>

  );

};

export default SimCards;